import React from "react";
import HomeUpper from "./homeUpper";
import HomeButtons from "./homeButtons";
import HomeSlider from "./homeSlider";
import HomepageTable from "./homepageTable";
import HomeUserguide from "./homeUserguide";
import HomeGlobal from "./homeGlobal";
import HomeExchange from "./homeExchange";
import { useSelector } from "react-redux";

export default function Homepage() {
  const userDetails = useSelector((state: any) => state.auth.auth);
  return (
    <>
      <div
        style={{
          background: "url('../../../assets/images/main/Bg-1.png')",
          color: "#fff",
        }}
      >
        <HomeUpper />
        <HomeButtons />
        <HomeSlider />
        <HomepageTable />
        <HomeUserguide />
        <HomeGlobal />
        <HomeExchange />
      </div>
    </>
  );
}
